import React, { useState, useEffect } from 'react';
import TitleBanner from './TitleBanner';
import { useNavigate } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const OurTeam = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const response = await fetch(BASE_URL+'/api/team');
        if (!response.ok) {
          throw new Error('Failed to fetch team data');
        }
        const data = await response.json();
        setTeamMembers(data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching team:', err);
        setError('Failed to load team members');
        setLoading(false);
      }
    };

    fetchTeam();
  }, []);

  const handleMemberClick = (member) => {
    navigate(`/team/${encodeURIComponent(member.name)}`, { state: { member } });
  };

  if (loading) {
    return <div className="text-center py-8">Loading team members...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-600">{error}</div>;
  }

  return (
    <div className="w-full">
      <TitleBanner 
        title="Our Team" 
        subheading="Meet the dedicated professionals making a difference in the lives of others."
        image="/Website_Title_Images/Our_Team.svg"
      />
      
      <div className="container mx-auto px-4 py-16">
        <h2 className="text-4xl font-arial-rounded font-bold text-primary text-center mb-12">
          Get to Know
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center cursor-pointer transform transition-transform duration-300 hover:scale-105"
              onClick={() => handleMemberClick(member)}
            >
              <div className="w-64 h-64 rounded-full overflow-hidden mb-4">
                <img
                  src={member.image_url}
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">
                {member.name}
              </h3>
              <p className="text-gray-600">
                {member.position}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
